import { registerPlugin } from '@capacitor/core';

export interface FirebaseCheckerPlugin {
  isFirebaseConfigured(): Promise<{ status: boolean }>;
}

const FirebaseChecker = registerPlugin<FirebaseCheckerPlugin>('FirebaseChecker');

export default FirebaseChecker;
